import React from "react";
import { graphql } from "gatsby";
import parse from "html-react-parser";

import SEO from "../components/helmet/SEO";
import Layout from "../components/layout/Layout";
import PostBlogNav from "../components/layout/blog-nav/post/BlogNav";
import Post from "../components/post/Post";
import ActionRelated from "../components/actions/Related";
import Contact from "../components/contact/Contact";
import PostRelated from "../components/post/Related";
import useSiteMetaData from "../hooks/useSiteMetadata";
import usePost from "../hooks/usePost";
import { RelatedArticlesProvider } from "../context/related-articles";
import { PostProvider } from "../context/post";
import { getFirstParagraphText } from "../utils/blog";
import ActionsContact from "../components/actions/Contact";
import Newsletter from "../components/post/Newsletter";
import EBook from "../components/post/EBook";
import About from "../components/post/About";
import {getUrl} from '../utils/url';

function PostTemplate({ pageContext, location }) {
  const { title, tags, heroImage, categories, html, customTopics } = usePost();
  const { siteUrl } = useSiteMetaData();
  const { slug } = pageContext;

  const canonicalHref = getUrl(siteUrl, location.pathname);
  const imageHref = getUrl(siteUrl, heroImage.publicURL);
  const postContent = parse(html, {
    replace: ({ name }) => {
      switch (name) {
        case "newsletter":
          return <Newsletter />;
        case "ebook":
          return <EBook />;
        case "about":
          return <About />;
      }
    },
  });

  return (
    <RelatedArticlesProvider
      categories={categories}
      tags={tags}
      slug={slug}
      limit={4}
    >
      <SEO
        showTwitterDescription
        showTwitterTitle
        title={title}
        description={getFirstParagraphText(html)}
        pathname={location.pathname}
        canonicalHref={canonicalHref}
        ogImage={imageHref}
        twitterImage={imageHref}
      />
      <Layout footerMoved>
        <PostBlogNav />
        <div className="background">
          <div className="postGrid container">
            <main className="postGrid__post">
              <Post>{postContent}</Post>
              <Contact />
            </main>
            <aside className="postGrid__actions">
              <div className="actions">
                <ActionsContact />
                <ActionRelated />
              </div>
            </aside>
          </div>
          <section className="container">
            <h2 className="h2">Related posts</h2>
            <PostRelated categories={categories} tags={tags} slug={slug} />
          </section>
        </div>
      </Layout>
    </RelatedArticlesProvider>
  );
}

export const query = graphql`
  query ($slug: String!, $authorImagePath: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      timeToRead
      frontmatter {
        title
        tags
        author
        categories
        dateUpdated
        customTopics
        customCTA
        customContactCTA
        customContactCTAIcon {
          childImageSharp {
            fluid(maxWidth: 50, maxHeight: 50) {
              ...GatsbyImageSharpFluid
            }
          }
          publicURL
        }
        heroImage {
          childImageSharp {
            fluid(maxWidth: 1200) {
              ...GatsbyImageSharpFluid
            }
          }
          publicURL
        }
      }
      fields {
        date
      }
    }
    authorImage: file(relativePath: { eq: $authorImagePath }) {
      childImageSharp {
        fluid(maxWidth: 42, maxHeight: 42) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;

export default (props) => {
  const { authorImage, markdownRemark } = props.data;

  return (
    <PostProvider markdownRemark={markdownRemark} authorImage={authorImage}>
      <PostTemplate {...props} />
    </PostProvider>
  );
};
